module.exports = __webpack_public_path__ + "img/huace16.c5c6f185.jpg";